/* tslint:disable */
/* eslint-disable */
/**
 * Appli métier
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: Yoda 1 & 2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// May contain unused imports in some cases
// @ts-ignore
import type { ApiBfr } from "./api-bfr"
// May contain unused imports in some cases
// @ts-ignore
import type { ApiBfrAnterieur } from "./api-bfr-anterieur"
// May contain unused imports in some cases
// @ts-ignore
import type { ApiBilan } from "./api-bilan"
// May contain unused imports in some cases
// @ts-ignore
import type { ApiCaf } from "./api-caf"
// May contain unused imports in some cases
// @ts-ignore
import type { ApiCalculatedData } from "./api-calculated-data"
// May contain unused imports in some cases
// @ts-ignore
import type { ApiIncomeStatement } from "./api-income-statement"
// May contain unused imports in some cases
// @ts-ignore
import type { ApiNumericData } from "./api-numeric-data"
// May contain unused imports in some cases
// @ts-ignore
import type { ApiPeriodPlanFinancement } from "./api-period-plan-financement"
// May contain unused imports in some cases
// @ts-ignore
import type { ApiRemboursementsEmprunts } from "./api-remboursements-emprunts"
// May contain unused imports in some cases
// @ts-ignore
import type { ApiTva } from "./api-tva"

export interface ApiFinancialPeriod {
  id: number
  noteId: string
  startDate: string
  endDate: string
  duration: number
  incomeStatement: ApiIncomeStatement
  tva: ApiTva
  caf: ApiCaf
  bfr: ApiBfr
  remboursementsEmprunts: ApiRemboursementsEmprunts
  besoinsFixes: ApiCalculatedData
  pointMort: ApiCalculatedData
  margeDeManoeuvre: ApiCalculatedData
  periodPlanFinancement: ApiPeriodPlanFinancement
  prelevementTns: ApiNumericData
  periodType: ApiFinancialPeriodPeriodTypeEnum
  benchMarkEffectif: number
  bilanCedant?: ApiBilan
  bfrAnterieur?: ApiBfrAnterieur
  bfrVariation: ApiCalculatedData
}

export const ApiFinancialPeriodPeriodTypeEnum = {
  PREVISIONNEL: "PREVISIONNEL",
  ANTERIEUR: "ANTERIEUR",
  INTERMEDIAIRE: "INTERMEDIAIRE"
} as const

export type ApiFinancialPeriodPeriodTypeEnum =
  (typeof ApiFinancialPeriodPeriodTypeEnum)[keyof typeof ApiFinancialPeriodPeriodTypeEnum]
